import insights from '@assets/icons/insights.svg';
import logo from '@assets/icons/logo.svg';
import union from '@assets/icons/union.svg';
import camera from '@assets/icons/camera.svg';
import graph from '@assets/icons/graph.svg';
import clipboard from '@assets/icons/clipboard.svg';
import robot from '@assets/icons/robot.svg';
import settings from '@assets/icons/settings.svg';
import logout from '@assets/icons/logout.svg';
import user from '@assets/icons/user.svg';
import password from '@assets/icons/password.svg';
import arrowLeft from '@assets/icons/arrow-left.svg';
import aprove from '@assets/icons/aprove.svg';
import error from '@assets/icons/error.svg';
import burger from '@assets/icons/burger.svg';
import ellipseOutside from '@assets/icons/ellipse-outside.svg';
import logoDark from '@assets/icons/logoDark.svg';
import logoLight from '@assets/icons/logoLight.svg';
import trash from '@assets/icons/trash.svg';
import copy from '@assets/icons/copy.svg';
import pyramid from '@assets/icons/pyramid.svg';
import newTab from '@assets/icons/new-tab.svg';
import maintenance from '@assets/icons/maintenance.svg';
import earth from '@assets/icons/earth.svg';
import alert from '@assets/icons/alert.svg';
import meter from '@assets/icons/meter.svg';
import vpnKeyOff from '@assets/icons/vpnKeyOff.svg';
import SettingsApplicationsIcon from '@assets/icons/robot.svg';
import AssignmentAdd from '@assets/icons/assignment_add.svg';
import DatabaseIcon from '@assets/icons/database.svg';
import centerFocusWeakIcon from '@assets/icons/center_focus_weak.svg';
import SupportIcon from '@assets/icons/support.svg';
import MobileBlockIcon from '@assets/icons/mobile_block.svg';
import idCardIcon from '@assets/icons/id_card.svg';
import userAttributesIcon from '@assets/icons/user_attributes.svg';
import switchAccess2Icon from '@assets/icons/switch_access_2.svg';
import ForkliftIcon from '@assets/icons/forklift.svg';








export const ICONS = {
  aprove,
  insights,
  logo,
  union,
  camera,
  graph,
  clipboard,
  robot,
  settings,
  logout,
  user,
  password,
  arrowLeft,
  error,
  burger,
  ellipseOutside,
  logoDark,
  logoLight,
  trash,
  copy,
  pyramid,
  newTab,
  maintenance,
  earth,
  alert,
  meter,
  vpnKeyOff,
  SettingsApplicationsIcon,
  AssignmentAdd,
  DatabaseIcon,
  centerFocusWeakIcon,
  SupportIcon,
  MobileBlockIcon,
  idCardIcon,
  userAttributesIcon,
  switchAccess2Icon,
  ForkliftIcon
};
